<template>
  <searchable-select
    :id="id"
    v-model="country"
    option_value="value"
    option_label="label"
    :options="countryOptions"
    :placeholder="
      $t('views.registrations._form.registration_step.select', this.locale)
    " 
  />
</template>

<script>
import SearchableSelect from "application/components/shared/SearchableSelect.vue"

export default {
  props: {
    id: null,
    locale: {
      default: "en",
    },
    name: null,
    value: null,
    required: null,
    selected: null,
    priorityCountries: {
      default: () => {
        return [];
      },
    },
  },

  components: { SearchableSelect },

  data() {
    return {
      list: {},
      country: this.selected,
    };
  },

  async mounted() {
    await this.getCountries();
    if (this.selected) {
      this.country = this.selected
      this.$emit("input", this.selected);
    }
  },

  watch: {
    country(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.country) {
          this.$emit("input", this.country);
        } else {
          this.$emit("input", "");
        }
      }
    },

    locale() {
      this.getCountries();
    },
  },

  computed: {
    countryLabel() {
      return this.$t(
        "views.registrations._address_fields.country",
        this.locale
      );
    },
    countryOptions() {
      const keys = this.priorityCountries.concat(Object.keys(this.list));
      return keys.map((key) => {
        return {
          label: this.label(this.list[key]),
          value: key,
        };
      });
    },
  },

  methods: {
    translatedCountries() {
      return import(
        /* webpackChunkName: "country-lang-[request]" */ `i18n-iso-countries/langs/${
          this.locale.split("-")[0]
        }.json`
      );
    },

    countries() {
      return import(
        /* webpackChunkName: "country-lang-[request]" */ `i18n-iso-countries/langs/en.json`
      );
    },

    label(countryName) {
      return Array.isArray(countryName) ? countryName[0] : countryName;
    },

    async getCountries() {
      let countriesList = null;
      try {
        countriesList = await this.translatedCountries();
      } catch (e) {
        countriesList = await this.countries();
      }
      this.list = countriesList.countries;
      this.list["TW"] = "Taiwan";
      if (this.value) {
        this.country = this.value;
      }
    },
  },
};
</script>
